import { Helmet } from 'react-helmet-async';
import { PageMeta } from 'constants/pages';
import {
  SITE_URL,
  SITE_NAME,
  DEFAULT_OG_IMAGE,
  DEFAULT_OG_IMAGE_TYPE,
  DEFAULT_LOCALE,
  TWITTER_HANDLE,
} from 'constants/siteMeta';

export const MetaHead: React.FC<{ pageMeta: PageMeta }> = ({ pageMeta }) => {
  const {
    url,
    title,
    description,
    ogImage = DEFAULT_OG_IMAGE,
    ogImageType = DEFAULT_OG_IMAGE_TYPE,
    ogType = 'website',
    ogLocale = DEFAULT_LOCALE,
    twitterCard = 'summary_large_image',
    publishedTime,
    modifiedTime,
    author,
    keywords,
    jsonLd,
  } = pageMeta;

  const canonical = `${SITE_URL}${url}`;
  const jsonLdItems = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      {keywords && keywords.length > 0 && (
        <meta name="keywords" content={keywords.join(', ')} />
      )}

      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:type" content={ogImageType} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content={ogLocale} />
      {ogType === 'article' && publishedTime && (
        <meta property="article:published_time" content={publishedTime} />
      )}
      {ogType === 'article' && modifiedTime && (
        <meta property="article:modified_time" content={modifiedTime} />
      )}
      {ogType === 'article' && author && (
        <meta property="article:author" content={author} />
      )}

      <meta name="twitter:card" content={twitterCard} />
      {TWITTER_HANDLE && <meta name="twitter:site" content={TWITTER_HANDLE} />}
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {jsonLdItems.map((item, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(item)}
        </script>
      ))}
    </Helmet>
  );
};
